import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

axiosInstance.interceptors.request.use((config) => {
  if (config.headers.Authorization === null) {
    delete config.headers.Authorization;
  } else if (config.headers.Authorization === undefined) {
    const token = localStorage.getItem("token");
    config.headers.Authorization = `Token ${JSON.parse(
      token === "undefined" || !token ? JSON.stringify("") : token,
    )}`;
  }

  const userRole = localStorage.getItem("role");
  if (userRole) {
    config.headers["x-gridkey-user-role"] = userRole;
  }

  return config;
});

export default axiosInstance;
